import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Main extends Component {
  render() {
    return (
      <div className="main height66 ">
        <div className="h-5/6 flex flex-col pl-32 mb-10 justify-around items-center">

          <Link to="/cat" className="flex w-52">
            <div className="flex flex-col flagcontainer mr-3">
              <div className="halfflag cat1"></div>
              <div className="halfflag cat2"></div>
              <div className="halfflag cat1"></div>
            </div>

            <div className="pt-1">
              <p>Català</p>
            </div>
          </Link>

          <Link to="/cas" className="w-52">
            <div className="flag spain mr-3"></div>
            <div className="pt-1">
              <p>Español</p>
            </div>
          </Link>

          <Link to="/en" className="w-52">
            <div className="flag en mr-3"></div>
            <div className="pt-1">
              <p>English</p>
            </div>
          </Link>

          <Link to="/fr" className="w-52">
            <div className="flag fr mr-3"></div>
            <div className="pt-1">
              <p>French</p>
            </div>
          </Link>

          <Link to="/de" className="w-52">
            <div className="flag de mr-3"></div>
            <div className="pt-1">
              <p>Deutsch</p>
            </div>
          </Link>

        </div>

        <div className="text-center text-sm italic blue">
					<p>Developed by <a href="https://github.com/mrnlts">@marinaCodes</a></p>
				</div>
      </div>
    )
  }
};

export default Main;